;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'imageSlider',
		defaults = {
			//
		};

	function Plugin(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);

		this.$imagesSlider = this.$element.find('.js-imageSlider__images');
		this.$thumbsSlider = this.$element.find('.js-imageSlider__thumbs');
		this.$captionsSlider = this.$element.find('.js-imageSlider__captions');

		this.init();
	}

	var methods = {
		init: function() {
			var self = this;

			this.$element.removeClass('hiddenOnLoad');
			this.initSlider();

			$(window).on('debouncedwidth', function() {
				self.destroySlider();
				self.initSlider();
			});

			if (window.matchMedia) {
				var mediaQueryList = window.matchMedia('print');

				mediaQueryList.addListener(function(mql) {
					if (mql.matches) {
						self.destroySlider();
					} else {
						self.initSlider();
					}
				});
			}

			window.onbeforeprint = self.destroySlider();
			window.onafterprint = self.initSlider();
		},

		initSlider: function() {
			this.initImagesSlider();
			this.initCaptionsSlider();

			if ($.getWindowWidth() >= 1024) {
				this.initThumbsSlider();
			}
		},

		destroySlider: function() {
			this.$imagesSlider.slick('unslick');
			this.$captionsSlider.slick('unslick');

			if ($.getWindowWidth() > 1024) {
				this.$thumbsSlider.slick('unslick');
			}
		},

		initImagesSlider: function() {
			var self = this;

			this.$imagesSlider.slick({
				arrows: false,
				dots: false,
				centerMode: true,
				centerPadding: '100px',
				infinite: false,
				speed: 500,
				slidesToShow: 1,
				prevArrow: '<div class="slick-prev slick-arrow"><div class="icon-arrow-left icon"><svg xmlns="http://www.w3.org/2000/svg"><path d="M15 21.18L5.729 12 15 2.82 12.146 0 0 12l12.146 12L15 21.18" /></svg></div></div>',
				nextArrow: '<div class="slick-next slick-arrow"><div class="icon-arrow-right icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 24"><path d="M0 2.8L9.3 12 0 21.2 2.9 24 15 12 2.9 0 0 2.8"/></svg></div></div>',
				responsive: [
					{
						breakpoint: 950,
						settings: {
							centerPadding: '20px',
							dots: true
						}
					}
				]
			});

			this.$imagesSlider.on('swipe', function(event, slick, direction) {
				if (direction === 'left') {
					self.$captionsSlider.slick('slickNext');
				}

				if (direction === 'right') {
					self.$captionsSlider.slick('slickPrev');
				}
			});

			// this.$imagesSlider.find('.slick-prev').on('click', function() {
			// 	self.$thumbsSlider.slick('slickPrev');
			// });

			// this.$imagesSlider.find('.slick-next').on('click', function() {
			// 	self.$thumbsSlider.slick('slickNext');
			// });
		},

		initThumbsSlider: function() {
			var self = this;

			this.$thumbsSlider.slick({
				asNavFor: '.js-imageSlider__images',
				infinite: false,
				speed: 500,
				slidesToShow: 5,
				prevArrow: '<div class="slick-prev slick-arrow"><div class="icon-arrow-left icon"><svg xmlns="http://www.w3.org/2000/svg"><path d="M15 21.18L5.729 12 15 2.82 12.146 0 0 12l12.146 12L15 21.18" /></svg></div></div>',
				nextArrow: '<div class="slick-next slick-arrow"><div class="icon-arrow-right icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 24"><path d="M0 2.8L9.3 12 0 21.2 2.9 24 15 12 2.9 0 0 2.8"/></svg></div></div>',
				responsive: [
					{
						breakpoint: 1350,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 1150,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 950,
						settings: 'unslick'
					}
				]
			});

			var slides = this.$thumbsSlider.find('.slick-slide');

			slides.on('click', function() {
				var id = $(this).data('slide');
				self.$imagesSlider.slick('slickGoTo', id - 1);
			});

			this.$imagesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				slides.removeClass('is-active');
				$(slides[nextSlide]).addClass('is-active');
				// self.$thumbsSlider.slick('slickGoTo', nextSlide);
				self.$captionsSlider.slick('slickGoTo', nextSlide);
			});
		},

		initCaptionsSlider: function() {
			this.$captionsSlider.slick({
				arrows: false,
				draggable: false,
				swipe: false,
				fade: true,
				cssEase: 'linear',
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				adaptiveHeight: true
			});
		}
	};

	$.extend(Plugin.prototype, methods);

	$.fn[pluginName] = function (options) {
		this.each(function() {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		if (this.length > 0) {
			$.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		}

		return this;
	};

})(jQuery, window, document);


// import lightGallery from 'lightgallery'
// import 'lg-share'

// $('.js-imageSlider-slider').on('init', function(event, slick, currentSlide, nextSlide) {
// 	$('.js-imageSlider-slider .slick-cloned a').removeAttr('data-lightbox')

// 	$(this).lightGallery({
// 		selector: '.imageSlider-img',
// 		downloadUrl: false,
// 		prevHtml: `
// 			<div class="">
// 				<div class="icon-arrow-rounded-large icon icon-stroke">
// 					<svg role="presentation">
// 						<use xlink:href="/images/sprites/icons-sprite.svg#icon-arrow-rounded-large"/>
// 					</svg>
// 				</div>
// 			</div>
// 		`,
// 		nextHtml: `
// 			<div class="">
// 				<div class="icon-arrow-rounded-large icon icon-stroke">
// 					<svg role="presentation">
// 						<use xlink:href="/images/sprites/icons-sprite.svg#icon-arrow-rounded-large"/>
// 					</svg>
// 				</div>
// 			</div>
// 		`,
// 	})
// })
